<div>Pixi FPS: {{ fps }}</div>
<div>Pixi renderer: {{ renderer }}</div>
<div>User Count: {{ userCount }}</div>
<div>
  <mat-form-field appearance="fill">
    <mat-label>SVC Interval (in seconds) </mat-label>
    <input matInput id="svc-seconds" type="text" [(ngModel)]="svcInterval" />
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="fill">
    <mat-label>SVC Min FPS to 'Bad Condition' </mat-label>
    <input matInput id="svc-fps-disable" type="number" [(ngModel)]="minFPSBadCondition" />
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="fill">
    <mat-label>SVC Min FPS to 'Condition Fixed' </mat-label>
    <input matInput id="svc-fps-enable" type="number" [(ngModel)]="minFPSConditionFixed" />
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="fill">
    <mat-label>SVC connection status to 'Bad Condition' </mat-label>
    <input matInput id="svc-connection-stats" type="text" [(ngModel)]="connectionStatusBadCondition" />
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="setParams()">Set</button>
</div>
